





































































/* Created- 03 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ActionListV2 from "@/Ui-Components/Common/List/ActionListV2.vue";
import { State, Action } from "vuex-class";

import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaCardFill from "@/Ui-Components/Common/Container/ParticaCardFill.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaWebsiteBase from "../../Base/ParticaWebsiteBase.vue";
import StateMixin from "../../../Mixins/StateMixin";
import { ListItemDTO, SubscriberDetailsDTO, SearchSubscriberDTO, AuthUser, Auth0UserDTO } from "../../../Generated/ParticaAPI";
import { ButtonConfig, ButtonType } from "../../../Models/Buttons";
import { eParticaAction, ParticaEvent, getActionName } from "../../../Models/ParticaEvent";
import { IWebsiteUserService } from "../../../BusinessServices/websiteusers";
import SubscriberDetails from "@/Ui-Components/Domain/Users/SubscriberDetails.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import CreateSubscriber from "@/Ui-Components/Domain/Users/CreateSubscriber.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import { FormFieldRules, IFormField, FormFieldProps } from "../../../Models/Components.model";

const namespace: string = "config";

@Component(
	{
		name: "UserManagement",
		components: {
			ParticaError,
			ParticaRowContainer,
			ParticaColumnContainer,
			ActionListV2,
			ParticaCard,
			ParticaCardFill,
			ParticaView,
			SubscriberDetails,
			ButtonList,
			CreateSubscriber,
			ParticaRightDrawer
		},
		mixins: [StateMixin]
	})
export default class UserManagement extends ParticaWebsiteBase {

	@Prop() private id: number;
	private query: string = "";
	private addbuttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.WEBSITE_SUBSCRIBER_ADD, label: "Add Subscriber", type: ButtonType.Normal } as ButtonConfig,
		{ action: eParticaAction.WEBSITE_SUBSCRIBER_IMPORT, label: "Import Subscribers", type: ButtonType.Normal } as ButtonConfig,
	];
	private buttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.WEBSITE_SUBSCRIBER_EXPIRY_UPDATE, label: "Update Expiry Date", type: ButtonType.Normal } as ButtonConfig,
	];
	private subscriberbuttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.WEBSITE_SUBSCRIBER_SELECT, label: "Select Subscriber", type: ButtonType.Normal } as ButtonConfig,
	];
	private createbuttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.WEBSITE_SUBSCRIBER_SAVE, label: "Save Subscriber", type: ButtonType.OK } as ButtonConfig,
	];
	private jsonimportbuttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.WEBSITE_SUBSCRIBER_DO_IMPORT, label: "Import Subscribers", type: ButtonType.OK } as ButtonConfig,
	];
	private listdata = [] as ListItemDTO[];
	private userService: IWebsiteUserService;
	private subscribers: AuthUser[] = [];
	private subscriber: SubscriberDetailsDTO = new SubscriberDetailsDTO();
	private newsubscriber: Auth0UserDTO = new Auth0UserDTO();

	private showimport: boolean = false;
	private showdetails: boolean = false;
	private showcreate: boolean = false;
	private connections: string[] = [];
	private jsonimport: string = "[]";
	private connection: string = "";

	private connectionconfig =
		{
			props: { name: "connection", placeholder: "Choose connection", label: "Auth0 connection", required: true } as FormFieldProps,
			rules: { required: true } as FormFieldRules
		} as IFormField;

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.WEBSITE_SUBSCRIBER_EXPIRY_UPDATE: {
					await this.userService.updateSubscriber(this.subscriber);
					this.ShowSnackbar("Expiry date updated.");
					break;
				}
				case eParticaAction.WEBSITE_SUBSCRIBER_ADD: {
					this.showcreate = true;
					break;
				}
				case eParticaAction.WEBSITE_SUBSCRIBER_IMPORT: {
					this.showimport = true;
					break;
				}
				case eParticaAction.WEBSITE_SUBSCRIBER_DO_IMPORT: {
					const result = await this.userService.importSubscribers(this.jsonimport, this.connection, this.id);
					this.showimport = false;
					if (result === true) {
						this.ShowSnackbar("Import complete.");
					} else {
						this.ShowSnackbar("Import partially failed. Check console for more information.");
					}
					break;
				}
				case eParticaAction.WEBSITE_SUBSCRIBER_SAVE: {
					await this.userService.createSubscriber(this.newsubscriber);
					this.ShowSnackbar("Subscriber created.");
					this.newsubscriber = new Auth0UserDTO();
					this.showcreate = false;
					break;
				}
				case eParticaAction.WEBSITE_SUBSCRIBER_SELECT: {
					const u: AuthUser = new AuthUser();
					u.userId = event.item.id;
					u.domainId = this.id;
					this.subscriber = await this.userService.getSubscriber(u);
					if (this.subscriber.expiry === undefined) {
						this.subscriber.expiry = new Date();
						this.ShowSnackbar(`No expiry set for ${this.subscriber.email}`);
					}
					this.showdetails = true;
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}


	private async search() {
		try {
			this.LoadingStart();
			const search: SearchSubscriberDTO = new SearchSubscriberDTO();
			search.domainId = this.id;
			search.email = this.query;
			this.subscribers = await this.userService.getSubscribers(search);
			this.listdata = [];
			if (this.subscribers === null) {
				this.ShowSnackbar("No subscribers found.");
			} else {
				this.subscribers.forEach(s => {
					this.listdata.push({ id: s.userId, label: s.email } as ListItemDTO);
				});
			}
		} catch (error) {
			this.ShowErrorDialog(error, "error searching for account.");
		} finally {
			this.LoadingEnd();
		}
	}


	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "User Management";
		this.userService = this.particaServices.getWebsiteUserService();
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getWebsiteNav(this.id);
			this.newsubscriber.domainId = this.id;
			this.connections = await this.userService.getConnections(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
